var _style, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBufandeoCuentaAtras(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 992.1 992.1",
    style: {
      enableBackground: "new 0 0 992.1 992.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.28;fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_00000181794511435133199530000003890222610249219724_);}\n\t.st3{opacity:0.5;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.7931,
    y1: 0.2486,
    x2: 495.7931,
    y2: 992.3745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01117318,
    style: {
      stopColor: "#F59D0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEC2C"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 495.8,
    cy: 496.3,
    r: 496.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.7,908.6C278.9,908.6,78,707.7,78,459.9c0-73.7,17.8-143.3,49.3-204.6c-45.4,69.3-71.8,152.1-71.8,241.1 c0,243.2,197.2,440.4,440.4,440.4c115.2,0,220-44.2,298.4-116.6C719.5,875.7,626.9,908.6,526.7,908.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096777474926976388940000000237001389222291107_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.793,
    y1: 0.2487,
    x2: 495.793,
    y2: 992.3745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007340605,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.0037435
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096777474926976388940000000237001389222291107_)"
    },
    d: "M495.8,0.2C221.8,0.2-0.3,222.3-0.3,496.3 s222.1,496.1,496.1,496.1s496.1-222.1,496.1-496.1S769.8,0.2,495.8,0.2z M495.8,975.9c-264.9,0-479.6-214.7-479.6-479.6 S230.9,16.8,495.8,16.8s479.6,214.7,479.6,479.6S760.6,975.9,495.8,975.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 695.7,
    cy: 103.1,
    r: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M750.8,118.8c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C745.9,107.8,750.8,112.8,750.8,118.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBufandeoCuentaAtras);
export default __webpack_public_path__ + "static/media/bufandeo-cuenta-atras.891c01efc67a34f289c1ef67f61f1876.svg";
export { ForwardRef as ReactComponent };